<template>
  <div class="container">
    <!-- <van-swipe
      class="swiper-carousel"
      :autoplay="3000"
      :show-indicators="false"
    >
      <van-swipe-item v-for="(image, index) in covers" :key="index">
        <img class="lazy_img" :src="image.imgUrl" />
      </van-swipe-item>
    </van-swipe> -->
    <HomeHeader />
    <div class="content-tabs">
      <van-tabs
        title-inactive-color="#888888"
        title-active-color="#008cd6"
        color="#008cd6"
        background="$white"
        v-model:active="active"
        sticky
        animated
        @click-tab="onClickTab"
      >
        <van-tab
          v-for="(tab, index) in tabsArray"
          :title="tab.describe"
          :name="tab.type"
          :key="index"
        >
          <template #title>
            <div class="slot-title">{{ tab.describe }}</div>
          </template>
          <template #default>
            <AwardPage v-if="tab.type == 'awardPage'" />
            <RankList v-if="tab.type == 'ranklist'" />
            <StatementPage v-if="tab.type == 'rule'" />
          </template>
        </van-tab>
      </van-tabs>
    </div>
    <div class="bottom-btn-pos" v-show="active == 'numlist'"><VoteBtn /></div>
    <Statement />
    <div class="activity-btn" @click="handleClick()">往期活动</div>
  </div>
</template>

<script>
import { Tab, Tabs } from "vant";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import Statement from "@/components/Statement.vue";
import AwardPage from "@/components/awardPage.vue";
import RankList from "@/components/RankList.vue";
import StatementPage from "@/components/StatementPage.vue";
import HomeHeader from "@/components/HomeHeader.vue";
import VoteBtn from "@/components/VoteBtn.vue";
import { useRouter, useRoute } from "vue-router";
import useShare from "@/plugins/useShare.js";

export default {
  name: "Home",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    Statement,
    HomeHeader,
    VoteBtn,
    AwardPage,
    RankList,
    StatementPage,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const tabsArray = ref([]);
    if (route.query.id) store.state.termId = Number(route.query.id);
    console.log("3有没有id", store.state.termId);
    const id = store.state.termId;

    let params = {
      term_id: id,
    };

    onMounted(() => {
      store.dispatch("getAppEnv", { params }).then(() => {
        if (store.state.countDown > 0) {
          tabsArray.value = [
            {
              describe: "获奖情况",
              type: "awardPage",
            },
            {
              describe: "排行榜",
              type: "ranklist",
            },
            {
              describe: "投票规则",
              type: "rule",
            },
          ];
        } else {
          tabsArray.value = [
            {
              describe: "获奖情况",
              type: "awardPage",
            },
            {
              describe: "排行榜",
              type: "ranklist",
            },
          ];
        }
      });
      useShare();
    });

    const handleClick = () => {
      router.push("/activity/?id=" + id);
    };

    const onClickTab = ({ name }) => {
      if (name === "ranklist") {
        const params = { term_id: id };
        store.dispatch("getRank", { params });
      }
    };
    return {
      // id,
      onClickTab,
      handleClick,
      covers: computed(() => store.state.covers),
      leftVoteNum: computed(() => store.state.leftVoteNum),
      tabsArray,
    };
  },
  data() {
    return {
      active: "awardPage",
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: $light-gray;
  position: relative;
}
.lazy_img {
  width: 100%;
  height: auto;
}
.content-tabs {
  // padding-top: 10px;
  .slot-title {
    font-weight: 600;
    font-size: 16px;
    height: 24px;
    display: inline-block;
    line-height: 22px;
  }
}
.bottom-btn-pos {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: white;
  z-index: 100;
  padding-bottom: env(safe-area-inset-bottom);
}
.activity-btn {
  position: absolute;
  top: 20px;
  right: 0;
  width: 65px;
  height: 26px;
  line-height: 26px;
  font-size: 14px;
  text-align: center;
  background-color: rgba(50, 50, 51, 0.7);
  border-radius: 12px 0 0 12px;
  color: #fff;
  padding: 0 6px;
}
</style>
